<template>
  <div class="generic-report-template" data-testid="generic-report-template">
    <section class="report-section">
      <h3>{{ $t('general-report-template-section') }}</h3>
      <div class="field">
        <label class="label">{{ $t('clinical-information-section') }}</label>
        <textarea class="textarea" rows="4" v-model="report.clinicalInformation" :maxlength="15000"></textarea>
      </div>
      <div class="field">
        <label class="label">{{ $t('macroscopic-finding-section') }}</label>
        <textarea class="textarea" rows="4" v-model="report.macroscopicFinding" :maxlength="15000"></textarea>
      </div>
      <div class="field">
        <label class="label">{{ $t('microscopic-finding-section') }}</label>
        <textarea class="textarea" rows="4" v-model="report.microscopicFinding" :maxlength="15000"></textarea>
      </div>
      <div class="field">
        <label class="label">{{ $t('generic-diagnosis-section') }}</label>
        <textarea class="textarea" rows="4" v-model="report.diagnosis" :maxlength="15000"></textarea>
      </div>
      <div class="field">
        <label class="label">{{ $t('generic-comment-section') }}</label>
        <textarea class="textarea" rows="3" v-model="report.comment" :maxlength="10000"></textarea>
      </div>
      <div class="field">
        <label class="label">{{ $t('final-interpretation') }}</label>
        <textarea
          class="textarea"
          rows="5"
          v-model="report.finalInterpretation"
          :maxlength="15000"
          data-testid="final-interpretation"
        ></textarea>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'GenericReportTemplate',
  props: {
    report: {
      type: Object,
      required: true
    }
  }
};
</script>
